import { Fragment, ReactNode } from 'react';

const URL_PATTERN = /(https?:\/\/[^\s<]+[^\s<.,;:!?)»"'])/g;

// Turns the URLs of a plain text into links. React escapes the rest, so the text stays safe.
export const linkify = (text: string): ReactNode[] =>
  text.split(URL_PATTERN).map((part, index) =>
    index % 2 === 1 ? (
      <a key={index} href={part} target="_blank" rel="noopener noreferrer" className="text-accent underline underline-offset-4 break-all">
        {part}
      </a>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    )
  );
